export const isPhoneNumberValid = (phone: string): boolean => !!/^[+]*[(]{0,1}[0-9]{1,4}[)]{0,1}[-\s\./0-9]*$/.exec(phone);
export const isEmailValid = (email: string): boolean => !!/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.exec(email);
export const isValidNumber = (no: any): boolean => {
  const num = Number(no);
  return Number.isInteger(num) && num > 0;
}
